/**
 * ChevronUpIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ChevronUpIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.995 16.496a1 1 0 0 1-.71-.29L12 9.913l-6.286 6.293a1.004 1.004 0 0 1-1.42-1.418l6.997-6.993a1 1 0 0 1 1.419 0l6.995 6.993a.999.999 0 0 1-.71 1.708" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ChevronUpIcon = makeIcon('ChevronUpIcon', ChevronUpIconSvg)
